let firmware = {
    version: "版本号",
    enterVersion: "请输入版本号",
    versionCode: "请输入1-999999的正整数",
    srcVersion: "源版本号",
    enterSrcVersion: "请输入源版本号",
    targetVersion: "目标版本",
    selTargetVersion: "请选择目标版本",
    versionName: "版本名称",
    enterVersionName: "请输入版本名称",
    addFirmware: "添加固件",
    updateFirmware: "更新固件",
    firmwareDetail: "固件详情",
    packageUrl: "文件地址",
    packageType: "包类型",
    fullPackage: "全量包",
    diffPackage: "差分包",
    diffPackageNote: "低版本(源版本号)到高版本(版本号)的差分包",

    addOtaTask: "添加升级任务",
    upgradeDetail: "任务详情",
    releaseUpgrade: "发布升级",
    cancelUpgrade: "取消升级",
    upgradeId: "升级序号",
    upgradeName: "升级名称",
    enterUpgradeName: "请输入升级名称",
    upgradeScope: "升级范围",
    selUpgradeScope: "请选择升级范围",
    selUpgradeType: "请选择升级类型",
    allDevice: "所有设备",
    checkedDevice: "部分设备",
    orgDevice: "机构下设备",
    unreleased: "未发布",
    released: "已发布",
    executeTime: "执行时间",
    executeNow: "立即执行",
    executeSelTime: "指定时间",
    confirmCancelRelease: "确定取消发布{name}吗？",
    targetDevice: "待升级设备",
    confirmDeleteDevice: "确定要移除设备{name}"

}

export default firmware
